export default "__VITE_ASSET__BuRMcGIg__"